import cloneDeep from 'lodash/cloneDeep';

export default defineNuxtPlugin(({ $store }) => {
  window.clientWorkState = cloneDeep($store.getters.getClientWorkState);
});
